/**
 * Created by pmnia on 06/02/15.
 */
(function () {
    'use strict';
    angular
        .module('blocks.modal')
        .directive('obtModalWrapper', obtModalWrapper);

    /* @ngInject */
    function obtModalWrapper() {
        return {
            restrict: 'E',
            transclude: true,
            template: require('html!./obt-modalWrapper.directive.html') ,
            scope: {
                modalTitle: '@',
                trackEvent: '@?',
                trackCategory: '@?',
                trackLabel: '@?'
            }
        }
    }
})();


/*****************
 ** WEBPACK FOOTER
 ** ./app/blocks/modal/obt-modalWrapper.directive.js
 ** module id = 91
 ** module chunks = 0
 **/